import IconSvg from './IconSvg';

export default IconSvg;
